import { useState } from 'react';
import { Header, PayoutInfo, PayoutSuccessDialog } from './components';
import { EarningContainer } from './styled';

const EarningBox = () => {
  const [isPayoutSuccessDialogOpen, setIsPayoutSuccessDialogOpen] =
    useState(false);

  const handlePayoutSuccessDialogClose = () => {
    setIsPayoutSuccessDialogOpen(false);
  };

  return (
    <>
      <EarningContainer>
        <Header />

        <PayoutInfo
          onPayoutSuccess={() => setIsPayoutSuccessDialogOpen(true)}
        />
      </EarningContainer>

      <PayoutSuccessDialog
        onClose={handlePayoutSuccessDialogClose}
        isOpen={isPayoutSuccessDialogOpen}
      />
    </>
  );
};

export default EarningBox;
